import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, IconButton } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
export const getHeaders = (handleOpenObservacion, handleOpenDetallePedido, handleCreatePDF) => [
  { field: "id", headerName: "Pedido N°", width: 100 },
  {
    field: "createdAt",
    headerName: "Fecha",
    width: 180,
    valueGetter: (params) => {
      const date = new Date(params.row.createdAt);
      return date.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
  },
  { field: "totalpedido", headerName: "Total", width: 90 },
  {
    field: "formapago",
    headerName: "Forma de Pago",
    width: 120,
    valueGetter: (params) => {
      const fp = Number(params.row.formapago);

      switch (fp) {
        case 0:
          return "Pago en Local";
        case 1:
          return "Transferencia";
        case 2:
          return "Mercado Pago";
        default:
          return "Sin definir";
      }
    },
  },
  {
    field: "pdf",
    headerName: "PDF",
    width: 50,
    sortable: false,
    renderCell: (params) => {
      return (
        <IconButton
          aria-label="imprimir pdf"
          color="primary"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!params.row?.id) return;
            handleCreatePDF(params.row);
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
      );
    },
  },
  {
    field: "acciones",
    headerName: "Articulos",
    width: 90,
    sortable: false,
    renderCell: (params) => (
      <IconButton
        aria-label="ver detalles"
        color="primary"
        onClick={() => handleOpenDetallePedido(params.row.id)}
      >
        <VisibilityIcon />
      </IconButton>
    ),
  },
  {
    field: "observacion",
    headerName: "Datos del Pedido",
    width: 120,
    sortable: false,
    renderCell: (params) => {
      const datosCli = params.row.datosCli;
      // Si es mercadoPago → muestro el ícono
      return (
        <IconButton
          aria-label="ver Detalle de Observacion"
          color="primary"
          onClick={() => handleOpenObservacion(params.row.observacion, params.row.id)}
        >
          <VisibilityIcon />
        </IconButton>
      );
    },
  }
];
